import React, { useState,useEffect} from 'react'
import "../../assets/style/eegisterProvider.css"
import TextField from '@mui/material/TextField';
import { Button } from '@mui/material';
import OTPInput, { ResendOTP } from "otp-input-react";
import { json, useNavigation } from 'react-router-dom';
import Web3 from "web3";
import Api from '../../utils/Api';
import { toast } from 'react-toastify';
import components from '../../components';
import { useNavigate,useParams } from 'react-router';
const VarifyEmail = () => {

let Navigater=  useNavigate()
const [OTP,setOTP]=useState("")
const [email,setemail]=useState("")
const [loaderState,setloaderState]=useState()

 

const onSubmit=async()=>{
     try {
          console.log("🚀 ~ file: varifyOTP.js:16 ~ VarifyOTP ~ OTP:", OTP)
               let  otpemail=localStorage.getItem("otpemail")
     
               const data=await Api.Api.post("/user/verifyEmail",{
                    "email":email,
                    })
                    localStorage.setItem("otpemail",email)
                    localStorage.setItem("otprole",data.data.role)

                                   toast.success(data.data.message)
                                   Navigater("/auth/resetPassword/varifyOTP")
                    
                    console.log("🚀 ~ file: varifyOTP.js:30 ~ onSubmit ~ data:", data)
                    
          
          
               
       
         
       
     } catch (error) {
          if(error.response){
               toast.error(error?.response?.data?.message)

          }else{
               toast.success("Something Went Wrong!")
 
          }
     }
  

}
  return (
    <div style={{ display:"flex",justifyContent:"center",marginTop:"10%", width: "100%", backgroundColor: "#F3F4F8" }}>
       <components.Loader.Back_Drop state={loaderState}/>
          
      <div  style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          width:"50%"
        }}>
      <span className='Loginheading'>
                    Verify Email 
            </span>
            <div className='LoginScreen'>
               
            <div style={{display:"flex",flexDirection:"column",justifyContent:"space-evenly"}}>
                      <div style={{display:"flex",justifyContent:"center",marginTop:10}}>
                          <span style={{width:"90%", fontFamily: 'Manrope, sans-serif'}}>Email</span>
                      </div>
                        <div style={{display:"flex",justifyContent:"center",marginTop:10}}>
                        <TextField onChange={(e)=>{
                         setemail(e.target.value)
                        }} style={{width:"90%"}} id="outlined-basic" label="Enter your Email" variant="outlined" />
                            {/* <input placeholder='Enter Your Provider Title' type='text' /> */}
                        </div>
                 </div>
               
                 <div style={{display:"flex",width:"90%",alignSelf:"center",justifyContent:"flex-end",paddingBottom:20}}>
                     <div style={{display:"flex",justifyContent:"space-evenly"}}>
                     <Button onClick={onSubmit} variant="contained">Send</Button>    
                 </div>
                 </div>

            </div>
      </div>    
    </div>
  )
}

export default VarifyEmail